export const buildHarvestLocationsEndpoint = (organizationSlug) => (
  `/api/harvest/locations?organization_slug=${encodeURIComponent(organizationSlug)}`
);

export const buildHarvestContactPayload = (formData, organizationSlug, locations) => {
  const payload = { ...formData, organization_slug: organizationSlug };

  if (formData.harvest_location_id === 'other') {
    if (!formData.custom_location?.trim()) {
      throw new Error('Please enter the custom harvest location name');
    }

    const otherLocation = locations.find(({ name }) => name.trim().toLowerCase() === 'other');
    if (!otherLocation) {
      throw new Error('Please ask an administrator to add an Other harvest location first');
    }

    payload.harvest_location_id = otherLocation.id;
    payload.custom_location_name = formData.custom_location;
  }

  return payload;
};
